(function(){
  // mobile menu
  var t=document.querySelector('[data-menu-toggle]'),n=document.querySelector('[data-nav]');
  if(t&&n){t.addEventListener('click',function(){n.classList.toggle('is-open')});}

  // hero slider
  document.querySelectorAll('[data-slider]').forEach(function(s){
    var slides=s.querySelectorAll('.hero__slide'),dots=s.querySelectorAll('.dot'),i=0,timer;
    if(slides.length<2)return;
    function go(k){i=(k+slides.length)%slides.length;slides.forEach(function(el,j){el.classList.toggle('is-active',j===i)});dots.forEach(function(el,j){el.classList.toggle('is-active',j===i)});}
    function auto(){clearInterval(timer);if(!matchMedia('(prefers-reduced-motion: reduce)').matches)timer=setInterval(function(){go(i+1)},6000);}
    var p=s.querySelector('[data-prev]'),x=s.querySelector('[data-next]');
    p&&p.addEventListener('click',function(){go(i-1);auto()});
    x&&x.addEventListener('click',function(){go(i+1);auto()});
    dots.forEach(function(d){d.addEventListener('click',function(){go(+d.dataset.dot);auto()})});
    auto();
  });

  // featured collection tabs + carousel arrows
  document.querySelectorAll('.feat').forEach(function(f){
    var tabs=f.querySelectorAll('[data-tab]'),panels=f.querySelectorAll('[data-panel]');
    tabs.forEach(function(tb){tb.addEventListener('click',function(){
      tabs.forEach(function(o){o.classList.toggle('is-active',o===tb)});
      panels.forEach(function(p){p.classList.toggle('is-active',p.dataset.panel===tb.dataset.tab)});
    })});
    panels.forEach(function(p){
      var tr=p.querySelector('[data-track]');
      p.querySelector('[data-cprev]').addEventListener('click',function(){tr.scrollBy({left:-340,behavior:'smooth'})});
      p.querySelector('[data-cnext]').addEventListener('click',function(){tr.scrollBy({left:340,behavior:'smooth'})});
    });
  });

  // product variant price
  var v=document.querySelector('[data-variant]'),pr=document.querySelector('[data-price]');
  if(v&&pr){v.addEventListener('change',function(){var o=v.options[v.selectedIndex];pr.textContent=o.dataset.price;});}

  // ajax add to cart (cards)
  document.querySelectorAll('[data-add-form]').forEach(function(f){
    f.addEventListener('submit',function(e){
      e.preventDefault();
      var b=f.querySelector('button'),old=b.textContent;b.textContent='ADDING...';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:f.querySelector('[name=id]').value,quantity:1})})
        .then(function(r){if(!r.ok)throw 0;return r.json()})
        .then(function(){return fetch('/cart.js').then(function(r){return r.json()})})
        .then(function(c){document.querySelectorAll('[data-cart-count]').forEach(function(el){el.textContent=c.item_count});b.textContent='ADDED \u2713';setTimeout(function(){b.textContent=old},1600)})
        .catch(function(){b.textContent=old;f.submit()});
    });
  });
})();
